export const PARANOIDI_PLANS = [
  {
    id: "free",
    name: "14 päivän kokeilu",
    badge: "Aloita tästä",
    price: "0 € / 14 päivää",
    shortPrice: "0 € / 14 päivää",
    description:
      "Testaa omaa Paranoidi-verkkosivua ja anna yleisön lähettää ensimmäiset biisitoiveet keikalla.",
    songLimit: 20,
    included: [
      "Max 20 biisiä",
      "Oma Paranoidi-verkkosivu yleisölle",
      "QR-koodi ja jaettava linkki",
      "Perusbiisikirjasto",
      "Vapaat biisitoiveet",
      "3 € näkyvyysnosto biisitoiveelle",
      "Esiintyjän oma Stripe-maksutili",
      "Paranoidi ei ota maksusta mitään välistä – vain Stripen normaali maksunkäsittelykulu vähennetään",
      "Biisien lisäys: biisi – esittäjä",
      "Biisikirjaston haku ja kielisuodatus",
      "Mahdollinen biisitoivearvonta erillisellä osallistumisvalinnalla",
      "Sopii palvelun kokeiluun",
    ],
    excluded: [
      "Ei WhatsApp-nappia",
      "Ei some- ja linkkiosiota",
      "Ei hero-kuvaa / brändäystä",
      "Ei biisien piilotusta yleisöltä",
      "Ei näkyvyyden massahallintaa",
      "Ei SEO-otsikkoa, SEO-kuvausta tai UKK-osiota",
      "Ei tapahtumia tai tapahtumakohtaisia biisitoiveitä",
      "Ei tiedostotuonteja",
      "Ei SongBook/ChordPro-tuontia",
      "Ei settilistoja",
      "Ei lukutilaa tai prompteria",
      "Ei keikkamuistia",
      "Ei raportteja tai sponsoreita",
    ],
  },
  {
    id: "basic",
    name: "Basic",
    badge: "Oma sivu käyttöön",
    price: "9,90 € / kk + alv",
    shortPrice: "9,90 € / kk + alv",
    description:
      "Kun haluat julkaista esiintyjän oman sivun kunnolla: kuva, esittely, linkit, UKK ja hallittu biisitoivepolku yleisölle.",
    songLimit: 100,
    included: [
      "Max 100 biisiä",
      "Kaikki kokeilun ominaisuudet",
      "Julkisen verkkosivun perustiedot",
      "Hero-kuva ja esittelytekstit",
      "Some-, nettisivu- ja WhatsApp-linkit",
      "Biisien piilotus ja palautus yleisön biisitoivehausta",
      "Näkyvyyssuodatin: kaikki, toivottavissa ja piilotetut",
      "Biisikirjaston massatoiminnot kielelle, tägeille ja näkyvyydelle",
      "SEO-otsikko ja SEO-kuvaus",
      "Usein kysytyt kysymykset julkiselle sivulle",
      "Toimii promosivuna myös silloin, kun biisitoiveet ovat kiinni",
    ],
    excluded: [
      "Ei tapahtumia tai tapahtumakohtaisia biisitoiveitä",
      "Ei tiedostotuonteja",
      "Ei SongBook/ChordPro-tuontia",
      "Ei settilistoja",
      "Ei lukutilaa tai prompteria",
      "Ei keikkamuistia",
      "Ei raportteja tai sponsoreita",
    ],
  },
  {
    id: "plus",
    name: "Plus",
    badge: "Suositeltu",
    price: "19,90 € / kk + alv",
    shortPrice: "19,90 € / kk + alv",
    description:
      "Paranoidin päätuote aktiiviseen keikkakäyttöön. Oma verkkosivu yleisölle, tapahtumakohtaiset biisitoiveet keikoille ja lukutila esiintyjälle.",
    songLimit: 500,
    featured: true,
    included: [
      "Max 500 biisiä",
      "Kaikki Basicin ominaisuudet",
      "Tapahtumat ja tapahtumakohtaiset biisitoiveet",
      "Tapahtuman oma biisitoiveraja",
      "Tapahtuman valinta julkisessa biisitoivelomakkeessa",
      "PDF/DOCX-tuonti",
      "SongBook/ChordPro-tuonti sanoille ja soinnuille",
      "Tuonti Drivestä jaetusta tiedostosta linkillä",
      "Biisien massatuonti",
      "Biisikirjaston massahallinta: kielet, tilaisuustägit ja näkyvyys",
      "Settilistageneraattori",
      "Tallennetut settilistat",
      "Settilistan keikkanäkymä",
      "Lukutila ja prompteri",
      "Säädettävä tekstikoko ja väriteemat",
      "PDF / tulostus",
      "Keikkamuisti",
      "Raportit ja biisitoivetilastot",
      "Sponsorit biisitoiveiden yhteyteen",
    ],
    excluded: [],
  },
];

const PLAN_TRANSLATION_ITEM_IDS = {
  free: {
    included: [
      "songLimit",
      "publicPage",
      "qrLink",
      "basicLibrary",
      "freeRequests",
      "boost",
      "stripeAccount",
      "stripeFee",
      "songEntry",
      "searchLanguage",
      "raffle",
      "trialUse",
    ],
    excluded: [
      "whatsapp",
      "socialLinks",
      "heroBranding",
      "songVisibility",
      "bulkVisibility",
      "seoFaq",
      "events",
      "fileImports",
      "songbookChordpro",
      "setlists",
      "readerPrompter",
      "gigNotes",
      "reportsSponsors",
    ],
  },
  basic: {
    included: [
      "songLimit",
      "trialFeatures",
      "publicBasics",
      "heroIntro",
      "socialWebsiteWhatsapp",
      "songVisibility",
      "visibilityFilter",
      "bulkLibrary",
      "seo",
      "faq",
      "promoWhenClosed",
    ],
    excluded: [
      "events",
      "fileImports",
      "songbookChordpro",
      "setlists",
      "readerPrompter",
      "gigNotes",
      "reportsSponsors",
    ],
  },
  plus: {
    included: [
      "songLimit",
      "basicFeatures",
      "events",
      "eventLimit",
      "publicEventSelection",
      "pdfDocx",
      "songbookChordpro",
      "driveImport",
      "bulkImport",
      "bulkLibrary",
      "setlistGenerator",
      "savedSetlists",
      "gigSetlist",
      "readerPrompter",
      "readerSettings",
      "printPdf",
      "gigNotes",
      "reportsStats",
      "sponsors",
    ],
    excluded: [],
  },
};

function translatePlanText(t, key, fallback) {
  if (typeof t !== "function") {
    return fallback;
  }

  return t(key, {
    defaultValue: fallback,
  });
}

export function getLocalizedParanoidiPlans(t) {
  if (typeof t !== "function") {
    return PARANOIDI_PLANS;
  }

  return PARANOIDI_PLANS.map((plan) => {
    const itemIds = PLAN_TRANSLATION_ITEM_IDS[plan.id] || {
      included: [],
      excluded: [],
    };

    return {
      ...plan,
      name: translatePlanText(
        t,
        `paranoidiPlans.${plan.id}.name`,
        plan.name
      ),
      badge: translatePlanText(
        t,
        `paranoidiPlans.${plan.id}.badge`,
        plan.badge
      ),
      price: translatePlanText(
        t,
        `paranoidiPlans.${plan.id}.price`,
        plan.price
      ),
      shortPrice: translatePlanText(
        t,
        `paranoidiPlans.${plan.id}.shortPrice`,
        plan.shortPrice
      ),
      description: translatePlanText(
        t,
        `paranoidiPlans.${plan.id}.description`,
        plan.description
      ),
      included: plan.included.map((item, index) =>
        translatePlanText(
          t,
          `paranoidiPlans.${plan.id}.included.${itemIds.included[index]}`,
          item
        )
      ),
      excluded: plan.excluded.map((item, index) =>
        translatePlanText(
          t,
          `paranoidiPlans.${plan.id}.excluded.${itemIds.excluded[index]}`,
          item
        )
      ),
    };
  });
}

export function getParanoidiPlan(planId, t) {
  const normalizedPlanId = String(planId || "free").toLowerCase();
  const plans =
    typeof t === "function"
      ? getLocalizedParanoidiPlans(t)
      : PARANOIDI_PLANS;

  return (
    plans.find((plan) => plan.id === normalizedPlanId) ||
    plans[0]
  );
}

export function getParanoidiPlanItems(planId, t) {
  const plan = getParanoidiPlan(planId, t);

  return plan.included;
}
